import { BaSeParagraph } from '@base/react';
import React from 'react';

// import { Container } from './styles';

function UfRegional({ uf }) {
  return (
    <>
      <BaSeParagraph color="#8B99A7">{uf}</BaSeParagraph>
    </>
  );
}

export default UfRegional;
